(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/trend/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/lb-ui/trend/assets/javascripts/utils.js');
"use strict";


const isTextOrNumber = value => typeof value === 'string' || typeof value === 'number';
setGlobal('svs.components.lbUi.trend.utils', {
  isTextOrNumber
});

 })(window);